import { FC } from "react";
import { Text } from "@chakra-ui/react";
import { Stars02 } from "~/icons";
import { useTrialDiscount } from "~/MemberApp/hooks";
import { Trans } from "~/utils/i18next";
import { BannerContainer } from "./BannerContainer";

export const TrialDiscountBanner: FC = () => {
  const trialDiscount = useTrialDiscount();
  const discountEndsAt = trialDiscount?.discountExpiresShort;
  const discount = trialDiscount?.discount;

  if (!trialDiscount?.discount) return null;

  return (
    <BannerContainer>
      <Stars02 h={4} w={4} mt="2px" />
      <Text variant="th-body3">
        <Trans
          i18nKey="planSelect.trialBanner.content"
          values={{ discountEndsAt, discount }}
        />
      </Text>
    </BannerContainer>
  );
};
